import { Unstable_Grid2 as Grid } from '@mui/material';

import { Select } from '@occc-app/design-system';

import { useConfig } from '@occc/config';
import { RetailerNetworkMultipleSelectField } from '@occc/feat-retailer-connect';
import { employeeStatusTargeting, operatorOptions } from './constants';

export type EmployeeStatusTargetingAttributeProps = {
  name: string;
};

export const EmployeeStatusTargetingAttribute = ({
  name,
}: EmployeeStatusTargetingAttributeProps) => {
  const { config } = useConfig();
  return (
    <Grid container columnSpacing={3} style={{ alignContent: 'flex-start' }}>
      <Grid xs={12} sm={4} style={{ marginTop: 16 }}>
        <Select
          name={`${name}.retailerNetworkUserType`}
          label='Employee Status'
          data={employeeStatusTargeting}
        />
      </Grid>
      <Grid xs={12} sm={4} style={{ marginTop: 16 }}>
        <Select
          name={`${name}.operator`}
          label='Choose a relation'
          data={operatorOptions}
          formControlProps={{ size: 'medium', margin: 'none' }}
        />
      </Grid>

      {config.retailerConnect.enabled && (
        <Grid xs={12} sm={4}>
          <RetailerNetworkMultipleSelectField
            label='Of this Retailer Network'
            name={`${name}.retailerNetworks`}
          />
        </Grid>
      )}
    </Grid>
  );
};
